import { createDefaultRoomConfig } from "../constants/defaults";
import { useSessionStore } from "./sessionMainStore";
import { useRoomStore } from "./roomStore";
import { usePlacedModelsStore } from "./placedModelsStore";
import { usePlexianStore } from "./plexianStore";
import { useMusicPlaybackStore } from "./musicPlaybackStore";

export function clearAllZustandStorage() {
  // Clear all persisted stores
  if (useSessionStore.persist) {
    useSessionStore.persist.clearStorage();
  }

  if (useRoomStore.persist) {
    useRoomStore.persist.clearStorage();
  }

  if (usePlacedModelsStore.persist) {
    usePlacedModelsStore.persist.clearStorage();
  }

  if (usePlexianStore.persist) {
    usePlexianStore.persist.clearStorage();
  }

  // Reset stores to default state
  useRoomStore.setState(createDefaultRoomConfig());

  usePlacedModelsStore.setState({
    placedModels: [],
  });

  usePlexianStore.setState({
    avatarConfig: null,
    avatarId: null,
    isSynced: false,
  });

  useMusicPlaybackStore.getState().stopAll();
}
